// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class CustomerInformation {
  customerName: string;
  customerID: string;
  endUserName: string;
  custAddress1: string;
  custAddress2: string;
  custCity: string;
  custState: string;
  custZipCode: string;
  customerSalesforceId: string;
}
